// 目录：
// 将声明的内容复制到屏幕可见区域
// 给图片添加alt属性，如果图片本身不带文字，则需要alt控制，如果图片带文字，需要写alt具体文字
// 给所有的svg判断是否包含aria-hidden，如果不包含，则添加
// 给所有的input添加aria-label，值是placeholder或者value；如果是required，则添加属性值aria-required=true

/**
 * 公告栏弹窗
 *
 */
function announcementAccessFun() {
  document.addEventListener("DOMContentLoaded", function () {
    const announcement = document.getElementById("accessibility-announcement");
    if (!announcement) return;
    
    // 创建一个函数来发布声明
    function announceAccessibilityStatement() {
      // 将声明的内容复制到屏幕可见区域
      const visibleAnnouncement = document.createElement("div");
      visibleAnnouncement.style.position = "absolute";
      visibleAnnouncement.style.top = "0";
      visibleAnnouncement.style.left = "0";
      visibleAnnouncement.style.width = "1px";
      visibleAnnouncement.style.height = "1px";
      visibleAnnouncement.style.overflow = "hidden";
      visibleAnnouncement.innerHTML = announcement.innerHTML;
      document.body.appendChild(visibleAnnouncement);
      // 移除声明内容（可选）
      setTimeout(() => {
        document.body.removeChild(visibleAnnouncement);
      }, 5000); // 保留一段时间以确保屏幕阅读器能够读取
    }

    // 调用函数发布声明
    announceAccessibilityStatement();
  });
}
/**
 * 新窗口打开外部链接
 *
 */
function targetlinkFun() {
  // ADA: Open a new window for external website links
  var links = document.querySelectorAll("a[href]");
  var currentHost = window.location.hostname;

  for (var i = 0; i < links.length; i++) {
    var link = links[i];
    // link.setAttribute("tabindex", "0"); // Removed: links are naturally focusable

    // 已有可见文字的链接不添加 aria-label，避免语音控制可见标签与可访问名称不一致
    var visibleText = link.textContent.replace(/\s+/g, " ").trim();

    if (!link.target && isExternalLink(link.href, currentHost)) {
      link.target = "_blank";
      // link.setAttribute("role", "button"); // Removed: links are links, not buttons
      
      if (visibleText) {
        link.setAttribute("aria-label", visibleText + ", open in a new tab");
      } else if (link.hasAttribute("aria-label")) {
        link.setAttribute(
          "aria-label",
          link.getAttribute("aria-label") + ", open in a new tab"
        );
      }
      
      link.rel = "noopener noreferrer nofollow";
    }
  }

  function isExternalLink(href, currentHost) {
    try {
        var url = new URL(href);
        return url.hostname !== currentHost;
    } catch (e) {
        return false;
    }
  }
}

/**
 * 去掉与链接可见文案 / 图片 alt 相同的 title，避免 WAVE「冗余标题文本」。
 * Support 富文本链接常自带 title="与锚文本相同"；aria-label（如新窗口提示）保留。
 */
function removeRedundantTitleAttrs() {
  document.querySelectorAll("a[title], img[title]").forEach((el) => {
    const title = (el.getAttribute("title") || "").replace(/\s+/g, " ").trim();
    if (!title) {
      el.removeAttribute("title");
      return;
    }

    const name =
      el.tagName === "IMG"
        ? (el.getAttribute("alt") || "").replace(/\s+/g, " ").trim()
        : (el.textContent || "").replace(/\s+/g, " ").trim();

    if (title === name) {
      el.removeAttribute("title");
    }
  });
}

/**
 * 给缺失 alt 的图片补上可访问文本。
 * 优先用附近标题/链接文案，避免整页统一写成 "Redragon" 触发
 * WAVE「A nearby image has the same alternative text」。
 */
function imgALTFun() {
  const GENERIC_FALLBACK = /^(redragon|redragonshop|image)$/i;

  function nearbyText(image) {
    const card =
      image.closest(
        ".inside-product, .card-wrapper, .card-product, .product-card, [class*='product-card'], a"
      ) || image.parentElement;
    if (!card) return "";

    const titleEl = card.querySelector(
      ".inside-product-title, .card__heading, .product-title, .gifts-pro-title, h2, h3, h4"
    );
    if (titleEl) {
      const title = titleEl.textContent.replace(/\s+/g, " ").trim();
      if (title) return title;
    }

    if (card.tagName === "A") {
      const linkText = card.textContent.replace(/\s+/g, " ").trim();
      if (linkText) return linkText.slice(0, 100);
    }

    return "";
  }

  const images = document.getElementsByTagName("img");
  let fallbackIndex = 0;

  Array.from(images).forEach((image) => {
    const currentAlt = (image.getAttribute("alt") || "").trim();
    const missingAlt = !image.hasAttribute("alt");
    const genericAlt = GENERIC_FALLBACK.test(currentAlt);

    if (!missingAlt && !genericAlt) return;

    // 装饰性背景图：空 alt，避免与邻近产品图重复
    if (
      image.classList.contains("inside-product-background") ||
      image.classList.contains("cause-item-background") ||
      /bg-img|background/i.test(image.className)
    ) {
      image.setAttribute("alt", "");
      image.setAttribute("aria-hidden", "true");
      return;
    }

    const contextAlt = nearbyText(image);
    if (contextAlt) {
      image.setAttribute("alt", contextAlt.slice(0, 100));
      return;
    }

    fallbackIndex += 1;
    image.setAttribute("alt", `Redragon product image ${fallbackIndex}`);
  });
}
/**
 * 给所有的svg判断是否包含aria-hidden，如果不包含，则添加
 *
 */
function svgariaFun() {
  const svgs = document.getElementsByTagName("svg");

  Array.from(svgs).forEach((svg) => {
    if (!svg.hasAttribute("aria-hidden") && !svg.hasAttribute("role") && !svg.hasAttribute("aria-label")) {
      svg.setAttribute("aria-hidden", "true");
      svg.setAttribute("focusable", "false");
    }
  });
}
/**
 * 给所有的input添加aria-label，值是placeholder或者value；如果是required，则添加属性值aria-required=true
 *
 */
function inputlabelFun() {
  const inputs = document.getElementsByTagName("input");

  Array.from(inputs).forEach((input) => {
    if (!input.hasAttribute("aria-label")) {
      const placeholder = input.getAttribute("placeholder");
      const value = input.value;
      const labelValue = placeholder || value;
      if (labelValue) {
        input.setAttribute("aria-label", labelValue);
      }
    }
    if (input.hasAttribute("required")) {
      input.setAttribute("aria-required", "true");
    }
  });
}

/**
 * 产品页内related video 页签内的图片动态加alt值，a标签动态加aria-label值
 *
 */
function tosotrwdvidoeFun() {
  if (document.body.classList.contains("template-product")) {
    // 获取所有具有样式名为 "rwd-video" 的元素
    var rwdVideos = document.getElementsByClassName("rwd-video");

    // 遍历每个 rwd-video 元素
    for (var i = 0; i < rwdVideos.length; i++) {
      var rwdVideo = rwdVideos[i];

      // 获取 rwd-video 元素内的 h2 元素、a 元素和图片元素
      var h2Element = rwdVideo.querySelector("h2");
      var aElement = rwdVideo.querySelector("a");
      var imgElement = rwdVideo.querySelector("img");

      if (h2Element && aElement) {
         // 设置 a 元素的 aria-label 属性为 h2 元素的文本内容
         aElement.setAttribute("aria-label", h2Element.textContent);
      }
      if (h2Element && imgElement) {
        // 设置图片元素的 alt 属性为 h2 元素的文本内容
        imgElement.alt = h2Element.textContent;
      }
    }
  }
}

// 按下ESC, 关闭弹窗
function closeDialog () {
  let scrollTop = "";
  $(document).on('keydown', function(event) {
    if (event.key === "Escape") {
      scrollTop = $(window).scrollTop(); // Capture current position before hiding
      $('.product_dialog').css('display', 'none')
      $('body').removeClass('noscroll')
      $(window).scrollTop(scrollTop); // Restore position
    }
  });
}

/**
 * Transcy 语言切换器使用 tabindex="1"，会脱离文档自然顺序，
 * 导致从购物车等元素 Tab 时跳过语言下拉。改为 tabindex="0"。
 */
function fixTranscySwitcherFocus() {
  const SELECTOR =
    '#transcyBtnSwitcher, .transcy-switcher-item-primary[role="button"], .header-language [role="button"][aria-label], .transcy-switcher-country[role="button"]';

  let scheduled = false;

  function normalizeTabIndex() {
    document.querySelectorAll(SELECTOR).forEach((el) => {
      const tabIndex = el.getAttribute("tabindex");
      if (tabIndex !== null && Number(tabIndex) > 0) {
        el.setAttribute("tabindex", "0");
      }
      el.style.pointerEvents = "auto";
      el.style.cursor = "pointer";
    });
  }

  normalizeTabIndex();

  const observeTarget =
    document.querySelector(".header-language") || document.body;
  if (!observeTarget) return;

  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    // 断开观察再改属性，避免 MutationObserver 死循环卡死页面
    observer.disconnect();
    requestAnimationFrame(() => {
      normalizeTabIndex();
      scheduled = false;
      observer.observe(observeTarget, {
        childList: true,
        subtree: true,
      });
    });
  });

  observer.observe(observeTarget, {
    childList: true,
    subtree: true,
  });
}

/**
 * Transcy 国旗图标旁已有语言名称，alt 重复朗读。
 * 将 .transcy-flag 的 alt 置空，避免与相邻可见文字重复。
 */
function fixTranscyFlagDuplicateAlt() {
  function clearFlagAlt() {
    document.querySelectorAll("img.transcy-flag").forEach((img) => {
      img.setAttribute("alt", "");
      img.setAttribute("aria-hidden", "true");
    });
  }

  clearFlagAlt();

  const observeTarget =
    document.querySelector(".header-language") || document.body;
  if (!observeTarget) return;

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    observer.disconnect();
    requestAnimationFrame(() => {
      clearFlagAlt();
      scheduled = false;
      observer.observe(observeTarget, { childList: true, subtree: true });
    });
  });

  observer.observe(observeTarget, { childList: true, subtree: true });
}

/**
 * Transcy 语言切换器 aria-label 需包含可见语言名称，供语音控制匹配。
 */
function fixTranscyVisibleAccessibleName() {
  function syncSwitcherLabel() {
    const switcher = document.getElementById("transcyBtnSwitcher");
    if (!switcher) return;
    const visibleText = switcher.textContent.replace(/\s+/g, " ").trim();
    if (!visibleText) return;
    const label = `${visibleText}, language switcher`;
    if (switcher.getAttribute("aria-label") !== label) {
      switcher.setAttribute("aria-label", label);
    }
  }

  syncSwitcherLabel();

  const observeTarget =
    document.querySelector(".header-language") || document.body;
  if (!observeTarget) return;

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    observer.disconnect();
    requestAnimationFrame(() => {
      syncSwitcherLabel();
      scheduled = false;
      observer.observe(observeTarget, { childList: true, subtree: true });
    });
  });

  observer.observe(observeTarget, { childList: true, subtree: true });
}

/**
 * 移除由旧逻辑误加的 aria-label，恢复链接原生可访问名称。
 */
function fixMismatchedLinkAriaLabels() {
  document.querySelectorAll("a[aria-label]").forEach((link) => {
    const visibleText = link.textContent.replace(/\s+/g, " ").trim();
    if (!visibleText) return;
    const ariaLabel = (link.getAttribute("aria-label") || "").trim();
    // 可见文字已足够描述链接，且 aria-label 与可见文字不一致时移除
    if (ariaLabel && ariaLabel !== visibleText && !ariaLabel.startsWith(visibleText + ",")) {
      if (link.classList.contains("card-text") || link.closest(".refer-reward")) {
        link.removeAttribute("aria-label");
      }
    }
  });
}

/**
 * WAVE "Broken ARIA menu" 兼容修复：
 * 第三方脚本有时会注入 role="menu"，但内部并不是 ARIA application menu（缺少 menuitem）。
 * 这种场景应降级为普通容器，避免错误菜单语义。
 */
function normalizeInvalidAriaMenus() {
  function downgradeInvalidMenus(root) {
    const scope = root && root.querySelectorAll ? root : document;
    const menus = scope.querySelectorAll('[role="menu"]');

    menus.forEach((menu) => {
      const hasMenuItem = menu.querySelector(
        '[role="menuitem"], [role="menuitemcheckbox"], [role="menuitemradio"]'
      );

      if (!hasMenuItem) {
        menu.removeAttribute('role');
        if (menu.getAttribute('aria-orientation') === 'vertical') {
          menu.removeAttribute('aria-orientation');
        }
      }
    });
  }

  downgradeInvalidMenus(document);

  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            if (node.matches?.('[role="menu"]')) {
              downgradeInvalidMenus(node.parentElement || document);
            } else if (node.querySelector?.('[role="menu"]')) {
              downgradeInvalidMenus(node);
            }
          }
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

/**
 * Judge.me 排序下拉用 <label> 包裹 <select>，但没有 for/id，
 * WAVE 等工具会报「孤立的表单标签 / Select missing label」。
 * 插件源码无法改，渲染后补上显式关联与可访问名称。
 * 仅产品页生效。
 */
function fixJudgemeSortDropdownLabel() {
  if (!document.body.classList.contains("template-product")) return;

  const root = document.querySelector("#judgeme_product_reviews");
  if (!root) return;

  function fix() {
    root
      .querySelectorAll("label.jdgm-sort-dropdown-wrapper")
      .forEach((label, index) => {
        const select = label.querySelector("select.jdgm-sort-dropdown");
        if (!select) return;

        const labelTextEl = label.querySelector(".jdgm-sort-dropdown-label");
        const name = (labelTextEl?.textContent || "").trim() || "Sort reviews";

        const selectId = select.id || `jdgm-sort-dropdown-${index}`;
        select.id = selectId;
        label.setAttribute("for", selectId);

        if (labelTextEl) {
          const labelId = labelTextEl.id || `${selectId}-label`;
          labelTextEl.id = labelId;
          if (!select.getAttribute("aria-labelledby")) {
            select.setAttribute("aria-labelledby", labelId);
          }
        } else if (!select.getAttribute("aria-label")) {
          select.setAttribute("aria-label", name);
        }
      });
  }

  fix();

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    observer.disconnect();
    requestAnimationFrame(() => {
      fix();
      scheduled = false;
      observer.observe(root, { childList: true, subtree: true });
    });
  });

  observer.observe(root, { childList: true, subtree: true });
}

/**
 * Judge.me 多处图片共用相同 alt（User picture /「作者 review photo」/ 勋章），
 * WAVE 会报 Nearby image has the same alternative text。
 * 插件源码无法改：画廊与评论图改为带序号的唯一描述；
 * 勋章若父链接已有 aria-label，则图片改 decorative（alt=""）。
 * 仅产品页生效。
 */
function fixJudgemeDuplicateAlts() {
  if (!document.body.classList.contains("template-product")) return;

  const root = document.querySelector("#judgeme_product_reviews");
  if (!root) return;

  const GENERIC_ALT =
    /^(user picture|customer (?:photo|video)(?: \d+(?: of \d+)?)?|.+ review (?:photo|video)(?: \d+(?: of \d+)?)?)$/i;

  function shouldRewriteAlt(alt) {
    const value = (alt || "").trim();
    return !value || GENERIC_ALT.test(value);
  }

  function isVideoImg(img) {
    return (
      !!img.closest(
        ".jdgm-gallery__thumbnail-link--video, .jdgm-rev__pic-link--video"
      ) || /video/i.test(img.getAttribute("data-type") || "")
    );
  }

  function syncLinkName(img, name) {
    const link = img.closest("a[aria-label], a.jdgm-rev__pic-link, a.jdgm-gallery__thumbnail-link");
    if (!link) return;
    // 避免链接 aria-label 与多张图重复同一文案
    if (link.hasAttribute("aria-label") || link.classList.contains("jdgm-rev__pic-link") || link.classList.contains("jdgm-gallery__thumbnail-link")) {
      link.setAttribute("aria-label", name);
    }
  }

  function updateGalleryAlts() {
    // 勋章：父 <a> 已有名称时，图本身改为装饰性，避免与相邻勋章/链接重复朗读
    root.querySelectorAll(".jdgm-medals-wrapper img, .jdgm-medal img, .jdgm-medal__image img").forEach((img) => {
      const link = img.closest("a[aria-label], a.jdgm-medal");
      const linkName = (link?.getAttribute("aria-label") || "").trim();
      if (linkName) {
        img.setAttribute("alt", "");
        return;
      }
      // 无父名称时保留/补一个唯一 alt（按勋章标题区分）
      const wrapper = img.closest(".jdgm-medal-wrapper");
      const title = (wrapper?.getAttribute("title") || img.getAttribute("alt") || "Judge.me medal")
        .replace(/\s+/g, " ")
        .trim();
      const short =
        title.length > 80 ? title.slice(0, 77) + "…" : title;
      if (shouldRewriteAlt(img.getAttribute("alt")) || !img.getAttribute("alt")) {
        img.setAttribute("alt", short);
      }
    });

    // 顶部媒体画廊缩略图
    root.querySelectorAll(".jdgm-gallery").forEach((gallery) => {
      const images = [
        ...gallery.querySelectorAll(
          "img.jdgm-gallery__thumbnail, .jdgm-gallery__thumbnail-wrapper img"
        ),
      ];
      const total = images.length;
      if (!total) return;

      images.forEach((img, index) => {
        if (!shouldRewriteAlt(img.getAttribute("alt"))) return;
        const kind = isVideoImg(img) ? "video" : "photo";
        const name = `Customer ${kind} ${index + 1} of ${total}`;
        img.setAttribute("alt", name);
        syncLinkName(img, name);
      });
    });

    // 每条评论内的多张图：同一作者共用「Zoe review photo」→ 加序号
    root.querySelectorAll(".jdgm-rev").forEach((rev) => {
      const author =
        (rev.querySelector(".jdgm-rev__author")?.textContent || "")
          .replace(/\s+/g, " ")
          .trim() || "Customer";
      const images = [
        ...rev.querySelectorAll(
          ".jdgm-rev__pics img, .jdgm-rev__image img, img.jdgm-rev__pic-img, a.jdgm-rev__pic-link img"
        ),
      ];
      const total = images.length;
      if (!total) return;

      images.forEach((img, index) => {
        if (!shouldRewriteAlt(img.getAttribute("alt"))) return;
        const kind = isVideoImg(img) ? "video" : "photo";
        const name = `${author} review ${kind} ${index + 1} of ${total}`;
        img.setAttribute("alt", name);
        syncLinkName(img, name);
      });
    });
  }

  updateGalleryAlts();

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    observer.disconnect();
    requestAnimationFrame(() => {
      updateGalleryAlts();
      scheduled = false;
      observer.observe(root, { childList: true, subtree: true });
    });
  });

  observer.observe(root, { childList: true, subtree: true });
}


/**
 * TDF Bundle（Smart Adds）插件：checkbox 用空 <label> 包裹，数量/规格无标签，
 * WAVE 会报 Empty/Missing form label，以及 Select missing label。
 * 插件源码无法改，渲染后按产品名补可访问名称与显式 label。
 * 仅产品页生效。
 */
function fixTdfBundleFormLabels() {
  if (!document.body.classList.contains("template-product")) return;

  const SR_STYLE =
    "position:absolute;width:1px;height:1px;padding:0;margin:-1px;overflow:hidden;clip:rect(0,0,0,0);white-space:nowrap;border:0;";

  function productTitle(item) {
    const titleEl = item.querySelector(
      ".tdf_vertical_title, .tdf_product_title, [class*='title']"
    );
    return (
      (titleEl?.textContent || "").replace(/\s+/g, " ").trim() || "product"
    );
  }

  function ensureSrLabel(control, labelClass, labelText, preferredId) {
    if (!control || !control.parentNode) return;

    const controlId = control.id || preferredId;
    control.id = controlId;
    if (!control.getAttribute("name")) {
      control.setAttribute("name", controlId);
    }

    let label =
      control.parentNode.querySelector(`label.${labelClass}[for="${CSS.escape(controlId)}"]`) ||
      (control.previousElementSibling?.classList?.contains(labelClass)
        ? control.previousElementSibling
        : null);

    if (!label) {
      label = document.createElement("label");
      label.className = `tdf-ada-sr-label ${labelClass}`;
      label.setAttribute("style", SR_STYLE);
      control.parentNode.insertBefore(label, control);
    }

    label.setAttribute("for", controlId);
    label.textContent = labelText;
    control.setAttribute("aria-label", labelText);
  }

  function fix() {
    const items = document.querySelectorAll(
      ".tdf_bundle .tdf_bundle_product_item, .tdf_bundle_product_item"
    );
    if (!items.length) return;

    items.forEach((item, index) => {
      const title = productTitle(item);

      const label = item.querySelector("label.tdf_checkbox_wrapper");
      const checkbox = item.querySelector("input.tdf_checkbox");
      if (label && checkbox) {
        const checkId = checkbox.id || `tdf-bundle-check-${index}`;
        checkbox.id = checkId;
        label.setAttribute("for", checkId);

        let sr = label.querySelector(".tdf-ada-label-text");
        if (!sr) {
          sr = document.createElement("span");
          sr.className = "tdf-ada-label-text";
          sr.setAttribute("style", SR_STYLE);
          label.appendChild(sr);
        }
        const checkName = `Select ${title} for bundle`;
        sr.textContent = checkName;
        label.removeAttribute("aria-label");
        checkbox.setAttribute("aria-label", checkName);
      }

      const qty = item.querySelector("input.tdf_qt_i");
      if (qty) {
        ensureSrLabel(
          qty,
          "tdf-ada-qty-label",
          `Quantity for ${title}`,
          `tdf-bundle-qty-${index}`
        );
      }

      const select = item.querySelector("select.tdf_select_input");
      if (select) {
        // WAVE「Select missing label」需要真正的 <label for>，仅 aria-label 不够
        ensureSrLabel(
          select,
          "tdf-ada-select-label",
          `Select variant for ${title}`,
          `tdf-bundle-variant-${index}`
        );
      }
    });
  }

  fix();

  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    observer.disconnect();
    requestAnimationFrame(() => {
      fix();
      scheduled = false;
      observer.observe(document.body, { childList: true, subtree: true });
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });
}

/**
 * 产品详情描述区：多张图共用超长营销文案 alt，WAVE 会报
 * Long alternative text / Nearby image has the same alternative text。
 * 改为「产品名, image n of m」。
 */
function fixProductDescriptionImageAlts() {
  if (!document.body.classList.contains("template-product")) return;

  const root = document.querySelector(
    ".product-single__description, #product-tab-content1 .rte, #product-tab-content1"
  );
  if (!root) return;

  const titleEl =
    document.querySelector("product-info h1, .product__info-container h1, h1.product__title") ||
    document.querySelector("h1");
  let title = (titleEl?.textContent || "").replace(/\s+/g, " ").trim() || "Product";
  // 避免 sticky / 重复节点把标题拼两次
  const half = Math.floor(title.length / 2);
  if (half > 10 && title.slice(0, half).trim() === title.slice(half).trim()) {
    title = title.slice(0, half).trim();
  }
  const shortTitle = title.length > 60 ? title.slice(0, 57) + "…" : title;

  const images = [...root.querySelectorAll("img")].filter((img) => {
    // 响应式隐藏的配对图仍计入，避免桌面/移动重复同一长 alt
    return true;
  });
  if (!images.length) return;

  const total = images.length;
  images.forEach((img, index) => {
    const alt = (img.getAttribute("alt") || "").trim();
    const tooLong = alt.length > 100;
    const looksGenericMarketing =
      /Smooth Lycra|Anti-Slip|Spill-Resistant|Perfect for Gaming/i.test(alt) ||
      (alt.length > 80 && alt.includes(title.slice(0, 20)));

    // 已是简短唯一序号则跳过
    if (/image \d+ of \d+$/i.test(alt) && alt.length <= 100) return;

    if (!alt || tooLong || looksGenericMarketing) {
      img.setAttribute("alt", `${shortTitle}, image ${index + 1} of ${total}`);
    }
  });
}

/**
 * Software / Download 页：产品图常用超长营销文案作 alt，WAVE 报 Long alternative text。
 * 超过 100 字符时改为相邻产品标题（截断）。
 */
function fixSoftwarePageLongImageAlts() {
  const roots = document.querySelectorAll(
    ".software-sets, .download-category__container, [data-download-category-container]"
  );
  if (!roots.length) return;

  const MAX = 100;

  roots.forEach((root) => {
    root.querySelectorAll(".download-category__product-image img, img").forEach((img) => {
      const alt = (img.getAttribute("alt") || "").replace(/\s+/g, " ").trim();
      if (alt.length <= MAX) return;

      const card = img.closest(".download-item, .download-category__product-item, li");
      const title =
        (card?.querySelector(".download-category__product-title")?.textContent || "")
          .replace(/\s+/g, " ")
          .trim() ||
        (card?.getAttribute("data-product-title") || "").trim() ||
        "Redragon product";

      const short =
        title.length > MAX ? title.slice(0, MAX - 1).trimEnd() + "…" : title;
      img.setAttribute("alt", short);
    });
  });
}

/**
 * 假变体标题（metafield 里的 selector-titleho）误用 <label>，
 * 实际关联的是链接列表而非表单控件，WAVE 会报 Orphaned form label。
 * 改为 <div>，保留 class 供样式与 variantMove 使用。
 */
function fixOrphanedVariantTitleLabels() {
  document
    .querySelectorAll(
      ".ProductSelect_variant label.selector-titleho, label.selector-titleho"
    )
    .forEach((label) => {
      if (label.getAttribute("for")) return;
      if (label.querySelector("input, select, textarea")) return;

      const replacement = document.createElement("div");
      replacement.className = label.className;
      replacement.innerHTML = label.innerHTML;
      [...label.attributes].forEach((attr) => {
        if (attr.name === "class") return;
        replacement.setAttribute(attr.name, attr.value);
      });
      label.replaceWith(replacement);
    });
}

announcementAccessFun();
targetlinkFun();
removeRedundantTitleAttrs();
fixMismatchedLinkAriaLabels();
imgALTFun();
svgariaFun();
inputlabelFun();
tosotrwdvidoeFun();
closeDialog();
fixTranscySwitcherFocus();
fixTranscyFlagDuplicateAlt();
fixTranscyVisibleAccessibleName();
normalizeInvalidAriaMenus();
fixJudgemeSortDropdownLabel();
fixJudgemeDuplicateAlts();
fixTdfBundleFormLabels();
fixProductDescriptionImageAlts();
fixSoftwarePageLongImageAlts();
fixOrphanedVariantTitleLabels();

/**
 * CPS / Mouse Tester 等产品卡片：图 alt 与标题相同时，前面加上页面描述，避免冗余朗读。
 */
function fixRedundantProductCardImageAlts(root) {
  const scope = root || document;
  const pageDesc = (
    document.querySelector(".rdc-header h1")?.textContent ||
    document.querySelector("h1")?.textContent ||
    document.title ||
    "Product page"
  )
    .replace(/\s+/g, " ")
    .trim();
  const prefix = pageDesc.length > 50 ? pageDesc.slice(0, 47) + "…" : pageDesc;

  const applyAlt = (img, titleEl) => {
    if (!img || !titleEl) return;
    const title = (titleEl.textContent || "").replace(/\s+/g, " ").trim();
    if (!title) return;
    const alt = (img.getAttribute("alt") || "").replace(/\s+/g, " ").trim();
    const desired = `${prefix} product: ${title}`;
    if (!alt || alt === title) {
      img.setAttribute("alt", desired);
    }
  };

  scope.querySelectorAll(".rdc-product-card").forEach((card) => {
    applyAlt(
      card.querySelector("img.rdc-product-img, img"),
      card.querySelector(".rdc-product-title")
    );
  });

  // Mouse Tester：#prodShelf .prod → img + <b> 标题
  scope.querySelectorAll("#prodShelf .prod, .prod-grid .prod").forEach((card) => {
    applyAlt(card.querySelector(".img-wrap img, img"), card.querySelector("b"));
  });
}

function watchRedundantProductCardImageAlts() {
  fixRedundantProductCardImageAlts();
  const targets = [
    document.getElementById("rdc-products"),
    document.querySelector(".rdc-products"),
    document.getElementById("prodShelf"),
    document.querySelector(".prod-grid"),
  ].filter(Boolean);
  if (!targets.length) return;

  const observer = new MutationObserver(() => fixRedundantProductCardImageAlts());
  targets.forEach((el) => observer.observe(el, { childList: true, subtree: true }));
}

watchRedundantProductCardImageAlts();

/**
 * CPS Test History 表：空状态短句会被 WAVE 疑为表格标题。
 * 补上 caption，并把空状态改成明确的说明文案。
 */
function fixCpsHistoryTableCaption() {
  const table = document.querySelector(".rdc-wrap table.rdc-table");
  if (!table) return;

  if (!table.querySelector(":scope > caption")) {
    const title =
      document.querySelector(".rdc-history-title")?.textContent?.replace(/\s+/g, " ").trim() ||
      "Test History";
    const caption = document.createElement("caption");
    caption.className = "visually-hidden";
    caption.textContent = title;
    table.insertBefore(caption, table.firstChild);
  }

  const emptyMsg =
    "No click speed tests recorded yet. Start clicking above to build your history.";
  table.querySelectorAll(".rdc-empty").forEach((cell) => {
    const text = (cell.textContent || "").replace(/\s+/g, " ").trim();
    if (!text || text === "No tests yet — start clicking!" || text.length < 45) {
      cell.textContent = emptyMsg;
    }
  });
}

function watchCpsHistoryTableCaption() {
  fixCpsHistoryTableCaption();
  const body = document.getElementById("rdc-history-body");
  if (!body) return;
  const observer = new MutationObserver(() => fixCpsHistoryTableCaption());
  observer.observe(body, { childList: true, subtree: true, characterData: true });
}

watchCpsHistoryTableCaption();

/**
 * CPS Challenge Mode 开关：原 checkbox 被 display:none，Tab 选不到。
 * 恢复可聚焦，并标明用途。
 */
function fixCpsChallengeToggleA11y() {
  const input = document.getElementById("rdc-challenge-chk");
  if (!input) return;

  input.setAttribute(
    "aria-label",
    "Challenge Mode. Turn on to set a CPS target and try to beat it during your click speed test"
  );
  input.setAttribute("role", "switch");

  const sync = () => {
    input.setAttribute("aria-checked", input.checked ? "true" : "false");
  };
  sync();
  if (!input.dataset.adaChallengeBound) {
    input.dataset.adaChallengeBound = "1";
    input.addEventListener("change", sync);
  }
}

fixCpsChallengeToggleA11y();

/**
 * CPS FAQ 手风琴：补充 aria-expanded，并隐藏装饰性 +/-，避免 NVDA 只报“按钮”不报折叠状态。
 */
function fixCpsFaqExpandedState() {
  const questions = document.querySelectorAll(".rdc-wrap .rdc-faq-q");
  if (!questions.length) return;

  questions.forEach((btn, index) => {
    const faqKey = btn.getAttribute("data-faq") || String(index);
    const panel =
      document.querySelector(`.rdc-wrap .rdc-faq-a[data-faq="${faqKey}"]`) ||
      btn.nextElementSibling;
    if (!panel) return;

    if (!panel.id) panel.id = `rdc-faq-panel-${faqKey}`;
    btn.setAttribute("aria-controls", panel.id);
    btn.setAttribute("aria-expanded", btn.classList.contains("open") ? "true" : "false");
    panel.setAttribute("role", "region");
    if (!panel.getAttribute("aria-labelledby") && btn.id) {
      panel.setAttribute("aria-labelledby", btn.id);
    } else if (!btn.id) {
      btn.id = `rdc-faq-btn-${faqKey}`;
      panel.setAttribute("aria-labelledby", btn.id);
    }

    btn.querySelectorAll(".rdc-faq-arrow").forEach((arrow) => {
      arrow.setAttribute("aria-hidden", "true");
    });
  });

  if (document.documentElement.dataset.adaCpsFaqBound) return;
  document.documentElement.dataset.adaCpsFaqBound = "1";
  document.addEventListener(
    "click",
    (e) => {
      const btn = e.target.closest(".rdc-wrap .rdc-faq-q");
      if (!btn) return;
      // Let page handler run first, then sync expanded state
      requestAnimationFrame(() => {
        document.querySelectorAll(".rdc-wrap .rdc-faq-q").forEach((q) => {
          q.setAttribute("aria-expanded", q.classList.contains("open") ? "true" : "false");
        });
      });
    },
    true
  );
}

fixCpsFaqExpandedState();

/**
 * CPS 统计卡片：数值与单位分开朗读。合并为一条可读文案。
 */
function fixCpsStatSpeech() {
  const stats = document.querySelectorAll(".rdc-wrap .rdc-stat");
  if (!stats.length) return;

  const buildLabel = (label, value) => {
    const key = label.replace(/\s+/g, " ").trim().toLowerCase();
    if (key.startsWith("time")) return `Time ${value} seconds`;
    if (key === "clicks") return `${value} clicks`;
    if (key === "cps") return `${value} CPS, clicks per second`;
    if (key === "cpm") return `${value} CPM, clicks per minute`;
    return `${value} ${label}`;
  };

  const sync = (stat) => {
    const valEl = stat.querySelector(".rdc-stat-val");
    const labelEl = stat.querySelector(".rdc-stat-label");
    if (!valEl || !labelEl) return;
    const value = (valEl.textContent || "").replace(/\s+/g, " ").trim();
    const label = (labelEl.textContent || "").replace(/\s+/g, " ").trim();
    const speech = buildLabel(label, value);
    stat.setAttribute("role", "group");
    stat.setAttribute("aria-label", speech);
    valEl.setAttribute("aria-hidden", "true");
    labelEl.setAttribute("aria-hidden", "true");
  };

  stats.forEach((stat) => {
    sync(stat);
    const valEl = stat.querySelector(".rdc-stat-val");
    if (!valEl || valEl.dataset.adaStatObserved) return;
    valEl.dataset.adaStatObserved = "1";
    const observer = new MutationObserver(() => sync(stat));
    observer.observe(valEl, { characterData: true, childList: true, subtree: true });
  });
}

fixCpsStatSpeech();

/**
 * 产品页特性图标连续朗读时补句号停顿（仅 template-product）。
 */
function fixProductIconWithTextSpeech() {
  if (!document.body.classList.contains("template-product")) return;

  document
    .querySelectorAll(".product__info-container .icon-with-text__item .h4")
    .forEach((el) => {
      if (el.querySelector(".ada-speech-sep")) return;
      const sep = document.createElement("span");
      sep.className = "visually-hidden ada-speech-sep";
      sep.textContent = ". ";
      el.appendChild(sep);
    });
}

fixProductIconWithTextSpeech();

/**
 * Judge.me 预览星级默认 aria-label 只有 "4.83 stars"，未说明是评论。
 * 在 Power Pink / Bundle Builder 卡片上改为：
 * "Rating 4.83 out of 5 stars, 12 customer reviews"
 */
function fixJudgemePreviewBadgeSpeech() {
  const selector =
    ".power-pink-product-row__rating, .anniversary-combo-sale__product-rating";
  if (!document.querySelector(selector)) return;

  let fixing = false;
  let scheduled = false;

  const apply = () => {
    if (fixing) return;
    fixing = true;
    try {
      document.querySelectorAll(selector).forEach((wrap) => {
        const badge = wrap.querySelector(".jdgm-prev-badge");
        if (!badge) return;

        const rating = badge.getAttribute("data-average-rating");
        const count = badge.getAttribute("data-number-of-reviews");
        if (rating == null || rating === "") return;

        const reviewCount = count == null || count === "" ? "0" : count;
        const label = `Rating ${rating} out of 5 stars, ${reviewCount} customer reviews`;

        if (wrap.getAttribute("aria-label") !== label) {
          wrap.setAttribute("aria-label", label);
        }

        const link = wrap.querySelector("a") || badge.querySelector("a");
        if (link && link.getAttribute("aria-label") !== label) {
          link.setAttribute("aria-label", label);
        }

        // DevTools 里常见的是这颗星星节点；覆盖 Judge.me 默认的 "4.83 stars"
        const stars = badge.querySelector(".jdgm-prev-badge__stars");
        if (stars && stars.getAttribute("aria-label") !== label) {
          stars.setAttribute("aria-label", label);
        }

        const text = badge.querySelector(".jdgm-prev-badge__text");
        if (text) text.setAttribute("aria-hidden", "true");

        badge.querySelectorAll(".jdgm-star, img, svg").forEach((node) => {
          if (node.getAttribute("aria-hidden") !== "true") {
            node.setAttribute("aria-hidden", "true");
          }
        });
      });
    } finally {
      fixing = false;
    }
  };

  apply();

  const observer = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      apply();
    });
  });

  document.querySelectorAll(selector).forEach((wrap) => {
    observer.observe(wrap, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["aria-label", "style", "class"],
    });
  });
}

fixJudgemePreviewBadgeSpeech();
